import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import theme from '../../../theme/theme';
import { SUB_HEADER } from '../config/employeeDetailTokens';
import { EmployeeHeaderIcon } from '../components/EmployeeHeaderIcon';
import { EmployeeTable } from '../components/EmployeeTable';

export function EmployeeListPage() {
  const { t } = useTranslation('common');

  return (
    <Box
      sx={{
        bgcolor: theme.palette.grey[50],
        height: `calc(100vh - ${theme.toolbar.height}px)`,
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
      }}
    >
      {/* Full-bleed header banner — same design as the employee detail SubHeader
          (SUB_HEADER token: light-primary background, shadow, icon + title size). */}
      <Box
        sx={{
          flexShrink: 0,
          display: 'flex',
          alignItems: 'center',
          gap: 2,
          px: 3,
          py: 2,
          background: SUB_HEADER.gradient,
          color: SUB_HEADER.color,
        }}
      >
        <EmployeeHeaderIcon />
        <Typography
          sx={{
            fontSize: theme.typography.employeeName.fontSize,
            fontWeight: theme.typography.fontWeightMedium,
            color: SUB_HEADER.buttonColor,
          }}
        >
          {t('employeeList.title')}
        </Typography>
      </Box>

      <Box sx={{ px: 3, pt: 3, pb: 3, flex: 1, minHeight: 0, display: 'flex', flexDirection: 'column' }}>
        <EmployeeTable />
      </Box>
    </Box>
  );
}
